import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { ApiTokensPage } from './-components/ApiTokensPage';

function ApiTokensRoute() {
  useSetBreadcrumbs([{ label: 'Settings' }, { label: 'API tokens' }]);
  return <ApiTokensPage />;
}

export const Route = createFileRoute('/settings/api-tokens')({
  component: ApiTokensRoute,
  errorComponent: ErrorComponent,
});
